module.exports = __webpack_public_path__ + "img/arrow-down.a952e119.svg";